import axios from 'axios';
import { CommonService } from './common.services';
export class EmpresaService extends CommonService {
    async findEmpresaBy(evento, id) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findEmpresaBy?evento=' + evento + '&idEmpresa=' + id, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findEmpresasBy(evento, moduloEmpresa) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findEmpresasBy?evento=' + evento + '&moduloEmpresa=' + moduloEmpresa, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findEmpresasProductosBy(evento) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findEmpresasProductosBy?evento=' + evento, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async saveOrUpdateAll(evento, empresas) {
        try {
            const empresasList = { "empresas": empresas };
            const response = await axios.post(this.getServerUrl() + '/mobile/saveOrUpdate?evento=' + evento, empresasList, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async saveOrUpdate(evento, empresa) {
        try {
            const empresasList = { "empresas": [empresa] };
            const response = await axios.post(this.getServerUrl() + '/mobile/saveOrUpdate?evento=' + evento, empresasList, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data[0];
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findUsuarioEmpresaBy(mailResponsable, pwd) {
        try {
            const dataForm = { "mail": mailResponsable, "pwd": pwd };
            const response = await axios.post(super.getServerUrl() + '/mobile/findUsuarioEmpresaBy?', dataForm, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async updateLogo(evento, empresa) {
        try {
            const dataForm = { "empresa": empresa };
            const response = await axios.post(super.getServerUrl() + '/mobile/updateLogo?evento=' + evento, dataForm, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return (response.data == "Ok");
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findProductosBy(evento, idEmpresa) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findProductosBy?evento=' + evento + '&idEmpresa=' + idEmpresa, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findProductoByPk(evento, idProducto) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findProductoByPk?idEvento=' + evento + '&idProducto=' + idProducto, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async removeProductoBy(evento, idProducto) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/removeProductoBy?evento=' + evento + '&idProducto=' + idProducto, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findTagsBy(evento, tipo) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findTagsBy?evento=' + evento + "&tipo=" + tipo, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async saveOrUpdateAllProductos(evento, productos) {
        try {
            const empresasList = { "empresaProductos": productos };
            const response = await axios.post(this.getServerUrl() + '/mobile/saveOrUpdateProductos?evento=' + evento, empresasList, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async saveOrUpdateProducto(evento, producto) {
        try {
            const empresasList = { "empresaProductos": [producto] };
            const response = await axios.post(this.getServerUrl() + '/mobile/saveOrUpdateProductos?evento=' + evento, empresasList, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data[0];
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async actualizarAccesoUsuarioEmpresa(evento, idUsuarioEmpresa, claveActual, claveNueva) {
        try {
            const response = await axios.post(this.getServerUrl() + '/mobile/actualizarAccesoUsuarioEmpresa?evento=' + evento + '&idUsuarioEmpresa=' + idUsuarioEmpresa + "&actual=" + claveActual + "&nueva=" + claveNueva, {}, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async asociarAcreditadoEmpresa(evento, idEmpresa, idAcreditado) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/asociarAcreditadoEmpresa?evento=' + evento + '&empresa=' + idEmpresa + "&acreditado=" + idAcreditado, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return (response.data == "OK");
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async desasociarAcreditadoEmpresa(evento, idEmpresa, idAcreditado) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/desasociarAcreditadoEmpresa?evento=' + evento + '&empresa=' + idEmpresa + "&acreditado=" + idAcreditado, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return (response.data == "OK");
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async cambiarAdministrador(evento, idEmpresa, idAcreditado) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/cambiarAdministrador?evento=' + evento + '&empresa=' + idEmpresa + "&acreditado=" + idAcreditado, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return (response.data == "OK");
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
}
